import {Map} from 'immutable'
import moment from 'moment'
import Firebase from 'firebase'

import firedux from '../firedux'
import {getState} from '../store'

import {
  SESSION_STATUSES,
  SESSION_TYPES,
  EXPERT_SESSIONS_ENDPOINT,
  EXPERT_SESSIONS_REF_USER_ENDPOINT
} from '../../config/constants'


const createExpertSession = (expertUid, userUid, sessionLength, startTime, type) => {
  // TODO: refactor this after changing users to complete immutable map
  const expert = getState().getIn(['users', expertUid])
  const user = getState().getIn(['users', userUid])
  let expertName, userName

  if (expert) expertName = Map.isMap(expert) ? expert.get('name') : expert.name
  if (user) userName = Map.isMap(user) ? user.get('name') : user.name

  const sessionData = {
    expert: expertUid,
    expertName: expertName,
    user: userUid,
    userName: userName,
    bookTime: Firebase.ServerValue.TIMESTAMP,
    type,
    startTime,
    sessionLength,
    status: SESSION_STATUSES.INITIATED
  }

  return firedux.ref.child(EXPERT_SESSIONS_ENDPOINT)
    .push(sessionData).then((snapshot) => snapshot.key())
}

export const createExpertSessionRef = (uid, otherUid, startTime, sessionId) => {
  const REF_ENDPOINT = EXPERT_SESSIONS_REF_USER_ENDPOINT(uid, otherUid)

  if (!startTime) startTime = moment().valueOf()

  const sessionRefObj = {
    sessionId, startTime
  }

  return firedux.ref.child(REF_ENDPOINT).child(sessionId).set(sessionRefObj).then(() => sessionId)
}

export default (expertUid, userUid, sessionLength, startTime = moment().valueOf(), type = SESSION_TYPES.IMMEDIATE) => {
  if (!expertUid) return
  if (!userUid) return

  return createExpertSession(expertUid, userUid, sessionLength, startTime, type)
    .then(createExpertSessionRef.bind(null, userUid, expertUid, startTime))
    .then(createExpertSessionRef.bind(null, expertUid, userUid, startTime))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/create_session_with_expert.js
 **/